import { FileDropDirective } from './../../utils/directives/file-drop.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { RecoverPasswordComponent } from './pages/recover-password/recover-password.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SignupComponent } from './pages/signup/signup.component';
import { SigninComponent } from './pages/signin/signin.component';
import { AuthAccountComponent } from './pages/signup/auth-account/auth-account.component';
import { SharedModule } from '../../modules/shared/shared.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ConfirmEmailComponent } from './pages/confirm-email/confirm-email.component';
import { NgxMaskModule } from 'ngx-mask';
import { MatDividerModule } from '@angular/material/divider';

import { AuthDocumentsComponent } from './pages/signup/auth-documents/auth-documents.component';
import { SigninQrDialogComponent } from './components/signin-qr-dialog/signin-qr-dialog.component';
import { QRCodeModule } from 'angularx-qrcode';
import { MatIconModule } from '@angular/material/icon';
import { SecondFactorAuthDialogComponent } from './components/second-factor-auth-dialog/second-factor-auth-dialog.component';
import { ConfirmExchangeComponent } from './pages/whitelabel/confirm-exchange/confirm-exchange.component';
import { WebcamComponent } from './components/webcam/webcam.component';
import { DialogYtWldComponent } from './pages/whitelabel/dialog-yt-wld/dialog-yt-wld.component';
import { DocButtonComponent } from './components/doc-button/doc-button.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { CuitConfirmationDialogComponent } from './components/cuit-confirmation-dialog/cuit-confirmation-dialog.component';
import { RedirectOnboardingComponent } from './pages/redirect-onboarding/redirect-onboarding.component';

@NgModule({
  declarations: [
    RecoverPasswordComponent,
    SignupComponent,
    SigninComponent,
    AuthAccountComponent,
    ConfirmEmailComponent,
    SecondFactorAuthDialogComponent,
    AuthDocumentsComponent,
    FileDropDirective,
    SigninQrDialogComponent,
    ConfirmExchangeComponent,
    WebcamComponent,
    DocButtonComponent,
    DialogYtWldComponent,
    UploadFileComponent,
    CuitConfirmationDialogComponent,
    RedirectOnboardingComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatDialogModule,
    SharedModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatDividerModule,
    MatIconModule,
    QRCodeModule,
    NgxMaskModule.forRoot(),
    MatProgressSpinnerModule,
  ],
  providers: [MatDatepickerModule],
})
export class AuthModule {}
